import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import GlobalError from '../components/GlobalError';
import { useSnackbar } from '../contexts/SnackbarProvider';
import axiosInstance from '../utils/axiosInstance';
import { Typography, Radio, RadioGroup, FormControlLabel, FormControl, Button, Paper, } from '@mui/material';
import ContractList from '../components/ContractList';
const SettingsPage = () => {
  const { showSnackbar } = useSnackbar();
  const [error, setError] = useState(null);
  const [contracts, setContracts] = useState([]);
  const [taxRates, setTaxRates] = useState([]);
  const [defaultRateId, setDefaultRateId] = useState(null);
  const navigate = useNavigate();
  useEffect(() => {
    const fetchTaxRates = async () => {
      try {
        const res = await axiosInstance.get('/config/tax-rates');
        if (Array.isArray(res.data)) {
          setTaxRates(res.data);
          const def = res.data.find((rate) => rate.is_default);
          if (def) setDefaultRateId(def.id);
        }
      } catch (err) {
        if (process.env.NODE_ENV === 'development') {
          console.error(err);
        }
        showSnackbar(
          err?.response?.data?.message || '税率の取得に失敗しました',
          'error'
        );
      }
    };

    fetchTaxRates();
  }, []);


  useEffect(() => {
    const fetchContracts = async () => {
      try {
        const res = await axiosInstance.get('/tenant/current-contract');
        setContracts(res.data);
      } catch (err) {
        if (process.env.NODE_ENV === 'development') {
          console.error(err);
        }
        setError(err?.response?.data?.message || '取得に失敗しました');
      }
    };

    fetchContracts();
  }, []);

  const handleDeleteAccount = async () => {
    if (!window.confirm('本当にアカウントを削除しますか？この操作は元に戻せません。')) {
      return;
    }

    try {
      const res = await axiosInstance.post('/tenant/delete');
      showSnackbar(res?.data?.message || 'アカウントを削除しました', 'success');
      setTimeout(async () => {
        await axiosInstance.post('/auth/logout');
        navigate('/login');
      }, 3000);
    } catch (err) {
      if (process.env.NODE_ENV === 'development') {
        console.error(err);
      }
      showSnackbar(err?.response?.data?.message || '削除に失敗しました', 'error');
    }
  };
  const handleSave = async () => {
    try {
      const res = await axiosInstance.put('/setting/tax-rates', { default_tax_rate_id: defaultRateId });
      showSnackbar(res?.data?.message || '保存しました', 'success');
    } catch (err) {
      if (process.env.NODE_ENV === 'development') {
        console.error(err);
      }
      showSnackbar(err?.response?.data?.message || '保存に失敗しました', 'error');
    }
  };

  if (error) return <GlobalError errorMessage={error} />;
  return (
    <>
      <Typography variant="h1" component="h1">基本設定</Typography>
      <Paper variant='section'>
        <Typography component='h2' variant="h4" sx={{ mb: 2 }}>
          消費税率のデフォルト設定
        </Typography>

        <FormControl>
          <RadioGroup
            row
            value={defaultRateId ?? ''}
            onChange={(e) => setDefaultRateId(Number(e.target.value))}
          >
            {taxRates.map((rate) => (
              <FormControlLabel
                key={rate.id}
                value={rate.id}
                control={<Radio />}
                label={`${rate.name}（${rate.rate}%）`}
              />
            ))}
          </RadioGroup>
        </FormControl>

        <div className="button-row">
          <Button variant="contained" onClick={handleSave}>
            保存
          </Button>
        </div>
      </Paper>
      <ContractList
        contracts={contracts}
        onDeleteAccount={handleDeleteAccount}
      />
    </>
  );
};

export default SettingsPage;
